import { useInstance, findDomFromVNode, nextTick } from 'intact-vue';
import { useState } from '../../hooks/useState';
import { cx } from '@emotion/css';
import { watchState } from '../../hooks/useState';
import { createContext } from '../context';
import { useResizeObserver } from '../../hooks/useResizeObserver';
import { isEqualObject } from '../utils';
export var context = createContext();
export function useFixedColumns(getColumns, _ref, widthMap) {
  var scrollRef = _ref.scrollRef,
    callbacks = _ref.callbacks;
  var instance = useInstance();
  var scrollPosition = useState(null);
  var hasFixed = useState(false);
  var offsetMap = useState({}, isEqualObject);
  var hasFixedLeft = false;
  var hasFixedRight = false;
  callbacks.push(setScrollPosition);
  instance.watch('children', handleFixedColumnsAndUpdate, {
    presented: true
  });
  watchState(widthMap, function () {
    return nextTick(handleFixedColumnsAndUpdate);
  });
  useResizeObserver(scrollRef, handleFixedColumnsAndUpdate, true);
  function handleFixedColumnsAndUpdate() {
    handleFixedColumns();
    updateScrollPositionOnResize();
  }
  function handleFixedColumns() {
    var columns = getColumns();
    var _offsetMap = {};
    hasFixedLeft = false;
    hasFixedRight = false;
    columns.forEach(function (columns, row) {
      columns.forEach(function (vNode, col) {
        var props = vNode.props;
        var key = props.key;
        var fixed = props.fixed;
        if (fixed === 'left') {
          var value = 0;
          var prevVNode = props.prevVNode;
          while (prevVNode) {
            var _props = prevVNode.props;
            if (_props.fixed === 'left') {
              value += getWidth(prevVNode);
            }
            prevVNode = _props.prevVNode;
          }
          _offsetMap[key] = value;
          hasFixedLeft = true;
        } else if (fixed === 'right') {
          var _value = 0;
          var nextVNode = props.nextVNode;
          while (nextVNode) {
            var _props2 = nextVNode.props;
            if (_props2.fixed === 'right') {
              _value += getWidth(nextVNode);
            }
            nextVNode = _props2.nextVNode;
          }
          _offsetMap[key] = _value;
          hasFixedRight = true;
        }
      });
    });
    offsetMap.set(_offsetMap);
    hasFixed.set(hasFixedLeft || hasFixedRight);
  }
  function setScrollPosition(scrollLeft) {
    if (!hasFixed.value) return;
    var scrollDom = scrollRef.value;
    var maxScroll = scrollDom.scrollWidth - scrollDom.offsetWidth;
    scrollPosition.set(scrollLeft === 0 ? 'left' : scrollLeft >= maxScroll ? 'right' : 'middle');
  }
  function updateScrollPositionOnResize() {
    var scrollDom = scrollRef.value;
    if (!hasFixed.value || scrollDom.scrollWidth - scrollDom.offsetWidth <= 0) {
      scrollPosition.set(null);
    } else {
      setScrollPosition(scrollRef.value.scrollLeft);
    }
  }
  return {
    scrollPosition: scrollPosition,
    setScrollPosition: setScrollPosition,
    hasFixed: hasFixed,
    offsetMap: offsetMap,
    getHasFixedLeft: function getHasFixedLeft() {
      return hasFixedLeft;
    }
  };
}
export function getClassAndStyleForFixed(_ref2, offset, k, checkType) {
  var _cx, _ref3;
  var className = _ref2.className,
    fixed = _ref2.fixed,
    align = _ref2.align;
  var extraOffset = checkType && checkType !== 'none' && fixed === 'left' ? 40 : 0;
  return {
    className: cx((_cx = {}, _cx[className] = !!className, _cx[k + "-fixed-" + fixed] = !!fixed, _cx[k + "-align-" + align] = !!align, _cx)),
    style: fixed ? (_ref3 = {}, _ref3[fixed] = offset + extraOffset + "px", _ref3) : null
  };
}
function getWidth(vNode) {
  var dom = findDomFromVNode(vNode, true);
  return dom.offsetWidth;
}